export const BuyingGroupDisplayStatus = {
  A: 'Active',
  C: 'Cancelled',
  E: 'Expired',
  P: 'Pending'
};
